/*
  Perro Loco — Botón flotante "volver arriba"

  Aparece pasadas dos pantallas de scroll y devuelve al inicio de la página.

  Dos detalles que no se ven leyendo el código:

  - El scroll se escucha con `requestAnimationFrame`, no en cada evento. En una
    colección larga el navegador dispara `scroll` decenas de veces por segundo
    y tocar clases en cada una hace saltar el desplazamiento en celular.

  - Al llegar arriba se reinicia el recorrido del teclado enfocando el <body>
    con `tabindex="-1"`. Sin eso, quien navega con teclado vuelve visualmente
    al inicio pero el foco sigue abajo, y el siguiente Tab lo devuelve al pie.

    ⚠️ Antes esto se hacía enfocando el primer enlace de la página, y ese
    enlace es el "Ir directamente al contenido": está oculto hasta que recibe
    foco, así que al subir aparecía solo un botón rojo arriba a la izquierda.
    Enfocar el <body> logra lo mismo sin mostrar nada. El `tabindex` se quita
    al perder el foco para no dejar el <body> enfocable de forma permanente.
*/
(function () {
  var boton = document.querySelector('.pl-arriba');
  if (!boton) return;

  var UMBRAL = window.innerHeight * 2;
  var pendiente = false;

  function revisar() {
    pendiente = false;
    boton.classList.toggle('is-visible', window.scrollY > UMBRAL);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(revisar);
    },
    { passive: true }
  );

  window.addEventListener('resize', function () {
    UMBRAL = window.innerHeight * 2;
    revisar();
  });

  boton.addEventListener('click', function () {
    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: suave ? 'smooth' : 'auto' });

    var cuerpo = document.body;
    cuerpo.setAttribute('tabindex', '-1');
    cuerpo.focus({ preventScroll: true });
    cuerpo.addEventListener(
      'blur',
      function () {
        cuerpo.removeAttribute('tabindex');
      },
      { once: true }
    );
  });

  revisar();
})();
